import script from "./FormGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./FormGenerator.vue?vue&type=script&setup=true&lang=js"

import "./FormGenerator.vue?vue&type=style&index=0&id=718897f9&lang=scss"

const __exports__ = script;

export default __exports__